/*
 * Copyright (c) 2021. Dave van Rijn Development
 */

import * as React from 'react';
import {Fragment, MouseEventHandler, PureComponent, ReactElement} from 'react';
import {ControlVariant, CustomAppEvent, IndexedObject} from '../util/interfaces';
import Dialog from './dialog';
import {generateComponentId} from "../util/componentUtil";
import {WithEvents} from "../../../index";

export interface DialogActionShape {
    label: string;
    onClick?: MouseEventHandler;
    primary?: boolean;
}

export type DialogActions = (DialogActionShape | string)[];

interface Props {
    className?: string;
}

interface State {
    dialogs: IndexedObject<ReactElement>
}

interface DataShape {
    message: string | React.ReactElement;
    title?: string;
    actions?: DialogActions;
    transparent?: boolean;
    persistent?: boolean;
    buttonVariant?: ControlVariant;
}

export default class DialogController extends PureComponent<Props, State> {
    state: State = {
        dialogs: {},
    };

    onClose = (id?: string) => {
        if (id) {
            const dialogs = Object.assign({}, this.state.dialogs);
            delete dialogs[id];
            this.setState({dialogs});
        }
    }

    onOpen = (data: DataShape) => {
        const dialogs = Object.assign({}, this.state.dialogs), id = generateComponentId();
        dialogs[id] = <Dialog open data={data} id={id} onClose={this.onClose}/>;
        this.setState({dialogs});
    };

    getEvents = (): CustomAppEvent[] => [
        {eventName: 'onOpenDialog', handler: this.onOpen},
    ];

    render = () => {
        const {className} = this.props;
        return <WithEvents events={this.getEvents()}>
            {Object.values(this.state.dialogs).map((element: ReactElement, key: number) => (
                <Fragment key={key}>
                    {React.cloneElement(element, {className})}
                </Fragment>
            ))}
        </WithEvents>
    }
}
